import HighlightTerm from "app/components/highlight-term/HighlightTerm";

import { GrowthOverviewSearchHighlight } from "./styled";

interface IGrowthOverviewHighlightedTextProps {
    text: string;
    searchHighlightTerm?: string;
}

export const GrowthOverviewHighlightedText = ({ text, searchHighlightTerm }: IGrowthOverviewHighlightedTextProps) => {
    if (!searchHighlightTerm) {
        return <>{text}</>;
    }

    return (
        <HighlightTerm
            sentence={text}
            highlightTerm={searchHighlightTerm}
            HighlightComponent={GrowthOverviewSearchHighlight}
        />
    );
};
